import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '料金はどのくらいかかりますか？',
    a: 'ご依頼内容によって異なりますが、WEBサイト制作はランディングページ ¥50,000〜、コーポレートサイト ¥150,000〜 を目安としています。SNS運用代行は月額 ¥19,800〜、MEO・SEO対策は月額 ¥20,000〜 から対応可能です。まずはお気軽にご相談ください。',
  },
  {
    q: '制作期間はどのくらいかかりますか？',
    a: 'ランディングページで最短3〜5日、コーポレートサイトで1〜2週間が目安です。AIを活用した制作フローにより、従来よりも大幅にスピードアップを実現しています。ページ数・機能・お客様のご確認スピードによって前後しますが、スケジュール優先の場合は別途ご相談ください。',
  },
  {
    q: '大阪以外でも対応できますか？',
    a: 'はい、全国どこでもオンラインで対応しています。ヒアリングから納品まですべてリモートで完結できますので、ご安心ください。必要に応じて現地訪問も対応可能です（交通費別途）。',
  },
  {
    q: '制作後のサポートはありますか？',
    a: '月額 ¥5,000〜 の保守プランをご用意しています。セキュリティ対応・テキスト修正・プラグイン更新など、公開後も安心してお任せいただけます。スポット対応も承りますのでご相談ください。',
  },
  {
    q: '複数のサービスをまとめてお願いできますか？',
    a: 'もちろん可能です。WEBサイト制作＋SNS運用代行＋MEO対策など、複数サービスを組み合わせてご依頼いただく場合は、トータルでご支援プランを組むことができます。まとめてお任せいただくほうがコスト面でもメリットがあります。',
  },
  {
    q: '予算が少ないのですが相談できますか？',
    a: 'はい、ぜひご相談ください。ご予算と優先度をヒアリングしたうえで、最適なプランを一緒に考えます。いきなりフルパッケージでなく、段階的に進めることも可能です。',
  },
  {
    q: 'SNSアカウントをまだ持っていないのですが大丈夫ですか？',
    a: '問題ありません。アカウント開設から戦略設計・投稿制作・運用まで、ゼロから一貫してサポートします。すでにアカウントをお持ちの方には、現状分析から改善提案まで丁寧に対応します。',
  },
  {
    q: '途中でデザインを変更したい場合はどうなりますか？',
    a: 'ご要望の内容・タイミングによって対応が異なりますが、制作途中の軽微な修正は基本的に追加費用なく対応しています。大幅な方向転換が必要な場合は、別途ご相談のうえ対応します。',
  },
];

const trustItems = [
  { icon: 'ri-shield-check-line', label: '初回相談無料', sub: '費用・内容の確認だけでもOK' },
  { icon: 'ri-time-line', label: '返信3営業日以内', sub: 'お問い合わせ後すぐにご連絡' },
  { icon: 'ri-map-pin-2-line', label: 'オンライン対応', sub: '全国どこでもリモートで完結' },
];

export default function HomeFAQ() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.faq-fade').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).classList.add('opacity-100', 'translate-y-0');
                (el as HTMLElement).classList.remove('opacity-0', 'translate-y-8');
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="py-28 bg-[#F5F8FF]" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="faq-fade opacity-0 translate-y-8 transition-all duration-700 mb-16 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="text-[#1E6FFF] text-xs tracking-[0.3em] mb-4 uppercase">/ FAQ</p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] tracking-tight leading-tight">
              よくある質問
            </h2>
          </div>
          <p className="text-[#888] text-sm leading-relaxed max-w-xs">
            お問い合わせ前に、よく寄せられるご質問をまとめました。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">

          {/* Left: FAQ Accordion */}
          <div className="lg:col-span-7 space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="faq-fade opacity-0 translate-y-8 transition-all duration-700 bg-white rounded-2xl overflow-hidden"
                style={{ border: '1px solid rgba(30,111,255,0.08)' }}
              >
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  className="w-full flex items-start gap-4 px-7 py-6 text-left cursor-pointer hover:bg-[#F5F8FF] transition-colors"
                >
                  <span
                    className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-white text-xs font-bold mt-0.5"
                    style={{
                      background: openIndex === i
                        ? 'linear-gradient(135deg, #1E6FFF, #0099FF)'
                        : '#0A1628',
                    }}
                  >
                    Q
                  </span>
                  <span className="flex-1 text-sm font-semibold text-[#0A1628] leading-snug pr-2">
                    {faq.q}
                  </span>
                  <span className="shrink-0 w-7 h-7 flex items-center justify-center mt-0.5">
                    <i
                      className={`ri-add-line text-[#888] text-lg transition-transform duration-300 ${
                        openIndex === i ? 'rotate-45 text-[#1E6FFF]' : ''
                      }`}
                    />
                  </span>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-400 ease-in-out ${
                    openIndex === i ? 'max-h-60' : 'max-h-0'
                  }`}
                >
                  <div className="px-7 pb-6 flex gap-4">
                    <span
                      className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-[#1E6FFF] text-xs font-bold mt-0.5"
                      style={{ background: 'rgba(30,111,255,0.1)' }}
                    >
                      A
                    </span>
                    <p className="text-[#555] text-sm leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right: Contact Card */}
          <div className="lg:col-span-5">
            <div className="faq-fade opacity-0 translate-y-8 transition-all duration-700 sticky top-28 space-y-4">

              {/* Trust items */}
              {trustItems.map((item) => (
                <div
                  key={item.label}
                  className="bg-white rounded-2xl px-6 py-5 flex items-center gap-4"
                  style={{ border: '1px solid rgba(30,111,255,0.1)' }}
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl shrink-0"
                    style={{ background: 'rgba(30,111,255,0.08)' }}
                  >
                    <i className={`${item.icon} text-[#1E6FFF] text-lg`} />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-[#0A1628] leading-tight">{item.label}</p>
                    <p className="text-xs text-[#999] mt-0.5">{item.sub}</p>
                  </div>
                </div>
              ))}

              {/* CTA Card */}
              <div
                className="rounded-2xl p-8"
                style={{ background: 'linear-gradient(135deg, #020B18 0%, #0A1E3D 100%)' }}
              >
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl mb-5"
                  style={{ background: 'rgba(30,111,255,0.2)' }}
                >
                  <i className="ri-chat-smile-2-line text-[#4DA3FF] text-xl" />
                </div>
                <p className="text-[#4DA3FF] text-xs tracking-[0.3em] mb-3 uppercase">/ Free Consultation</p>
                <h3 className="text-xl font-bold text-white mb-3 leading-snug">
                  解決しない場合は、<br />お気軽にご相談ください
                </h3>
                <p className="text-white/50 text-sm leading-relaxed mb-7">
                  初回相談は無料です。費用感・スケジュール・<br />
                  何でも遠慮なくどうぞ。
                </p>
                <Link
                  to="/contact"
                  className="w-full flex items-center justify-center gap-2 text-white py-4 rounded-full text-sm tracking-widest font-bold transition-all whitespace-nowrap hover:opacity-90"
                  style={{ background: 'linear-gradient(90deg, #1E6FFF 0%, #0099FF 100%)' }}
                >
                  <i className="ri-mail-send-line" />
                  無料相談を申し込む
                </Link>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
